import y from "lodash/isArrayLikeObject";
import l from "lodash/isDate";
import h from "lodash/isPlainObject";
const j = (t) => Object.prototype.toString.call(t).slice(8, -1) === "Object";
function f(t) {
  return !!(t && t.month && t.year);
}
function m(t, n) {
  return !f(t) || !f(n) ? !1 : t.year === n.year ? t.month < n.month : t.year < n.year;
}
function c(t, n) {
  return !f(t) || !f(n) ? !1 : t.year === n.year ? t.month > n.month : t.year > n.year;
}
function g(t, n, e) {
  return t ? !m(t, n) && !c(t, e) : !1;
}
function O(t) {
  return t ? {
    month: t.getMonth() + 1,
    year: t.getFullYear()
  } : null;
}
function D({ month: t, year: n }, e) {
  const r = e > 0 ? 1 : -1;
  for (let i = 0; i < Math.abs(e); i++)
    t += r, t > 12 ? (t = 1, n++) : t < 1 && (t = 12, n--);
  return {
    month: t,
    year: n
  };
}
function x() {
  return O(/* @__PURE__ */ new Date());
}
function M(...t) {
  return t.reduce((n, e) => n ? e && c(e, n) ? e : n : e);
}
function w(t, n) {
  const e = l(t), r = l(n);
  return !e && !r ? !0 : e !== r ? !1 : t.getTime() === n.getTime();
}
function A(t) {
  return y(t) && t.length;
}
function F(t, n, e) {
  const r = [];
  return e.forEach((i) => {
    const s = i.name || i.toString(), { mixin: o, validate: a } = i;
    if (Object.prototype.hasOwnProperty.call(t, s)) {
      const u = a ? a(t[s]) : t[s];
      n[s] = o && h(u) ? { ...o, ...u } : u, r.push(s);
    }
  }), {
    target: n,
    assigned: r.length ? r : null
  };
}
export {
  D as addPages,
  A as arrayHasItems,
  w as datesAreEqual,
  M as getMaxPage,
  j as isObject,
  F as mixinOptionalProps,
  O as pageForDate,
  x as pageForThisMonth,
  c as pageIsAfterPage,
  m as pageIsBeforePage,
  g as pageIsBetweenPages,
  f as pageIsValid
};
//# sourceMappingURL=helpers.js.map
